(function ($) {

// boolean directive to show placeholder as a label above the element.
angular.module('components.floatLabel', [])
    .directive('floatLabel', ['$timeout', function ($timeout) {
        var placeholderSupport = ("placeholder" in document.createElement("input"));
        var isIE = $.browser.msie;

        if (isIE && !placeholderSupport) {
            $('body').addClass('ie');
        }
            
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attr, ctrl) {
                var parent = element.parent();

                function hideLabel () {
                    parent.removeClass('field-active');
                };

                function showLabel () {
                    parent.addClass('field-active');
                };

                function toggleInvalidClass(invalid) {
                    (invalid)
                        ? parent.addClass('field-invalid')
                        : parent.removeClass('field-invalid');
                };

                function validator(value) {
                    !isEmpty(ctrl.$viewValue) || (isIE && ctrl.$dirty === true) ? showLabel() : hideLabel();
                    toggleInvalidClass(ctrl.$invalid);
                    return value;
                };

                if (isIE) {
                    element.on({
                        'focus': function () {
                            $timeout(showLabel, 1);
                        },
                        'blur': function () {
                            if (isEmpty($.trim(element[0].value))) {
                                $timeout(hideLabel, 1);
                            }
                        }
                    });
                };

                ctrl.$formatters.push(validator);
                ctrl.$parsers.push(validator);

                attr.$observe('placeholder', function () {
                    validator(ctrl.$viewValue);
                });
            }
        };
    }]);

function isEmpty(value) {
    return angular.isUndefined(value) || value === '' || value === null || value !== value;
}

}(jQuery));